
import React, { useState, useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faShuffle,
  faSpinner,
  faCircleExclamation
} from '@fortawesome/free-solid-svg-icons';

import TopBar from '../../functionalpagelogin/topBar/TopBar';

import testeconta from '../../functionalpagelogin/images/testeconta.png';

import './TesteContabilitate.css';

// ==========================================
// CONFIGURARE
// ==========================================

const COURSE_ID = 5;

const variante = Array.from(
  { length: 50 },
  (_, index) => index + 1
);

const TesteContabilitate = () => {

  const navigate = useNavigate();

  // ==========================================
  // STATE
  // ==========================================

  const [loadingTest, setLoadingTest] = useState(false);

  const [loadingVariant, setLoadingVariant] = useState(null);

  const [testError, setTestError] = useState('');

  const requestInProgressRef = useRef(false);

  // ==========================================
  // INCARCARE TEST DIN BACKEND
  // ==========================================

  const loadTest = async (variantNumber) => {

    // Prevenim cererile multiple simultane.
    if (requestInProgressRef.current) {
      return;
    }

    requestInProgressRef.current = true;

    setLoadingTest(true);
    setLoadingVariant(variantNumber);
    setTestError('');

    const isRandomTest = variantNumber === 'random';

    const endpoint = isRandomTest
      ? '/teste-contabilitate/random'
      : `/teste-contabilitate/varianta/${variantNumber}`;

    try {

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Accept': 'application/json'
          }
        }
      );

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error(
            'Trebuie sa fii autentificat pentru a accesa testele.'
          );
        }

        if (response.status === 403) {
          throw new Error(
            'Acest test este disponibil doar pentru utilizatorii Premium.'
          );
        }

        throw new Error(
          data?.error || 'Nu s-a putut incarca testul.'
        );
      }

      if (
        !Array.isArray(data.questions) ||
        data.questions.length === 0
      ) {
        throw new Error(
          'Acest test nu contine inca intrebari.'
        );
      }

      // ==========================================
      // CONSTRUIM LECTIA COMPATIBILA CU
      // CHAPTERCONTAINER
      // ==========================================

      const testTitle = isRandomTest
        ? 'Test aleatoriu'
        : `Varianta ${variantNumber}`;

      const lessonId = isRandomTest
        ? 999
        : Number(variantNumber);

      const lessonData = {
        title: testTitle,
        lesson: lessonId,
        explanationType: 'test',
        questions: data.questions
      };

      // ==========================================
      // DESCHIDEM QUIZUL
      // ==========================================

      navigate('/chaptercontainer', {
        state: {
          chapterId: 1,
          lessonId,
          courseId: COURSE_ID,
          courseName: 'Teste de contabilitate',

          isAccountingTest: true,
          variantNumber,

          lessonData,

          isReplayLesson: false,
          isActualJump: false
        }
      });

    } catch (error) {

      console.error(
        'Eroare la incarcarea testului:',
        error
      );

      setTestError(
        error.message ||
        'A aparut o eroare neasteptata.'
      );

    } finally {

      requestInProgressRef.current = false;

      setLoadingTest(false);
      setLoadingVariant(null);

    }
  };

  // ==========================================
  // SELECTARE VARIANTA
  // ==========================================

  const handleStartTest = (variantNumber) => {
    loadTest(variantNumber);
  };

  // ==========================================
  // TEST ALEATORIU
  // ==========================================

  const handleRandomTest = () => {
    loadTest('random');
  };

  // ==========================================
  // INTERFATA
  // ==========================================

  return (
    <div className="teste-contabilitate">

      <div className="teste-contabilitate__container">

        {/* TOP BAR */}

        <div className="teste-contabilitate__topbar">
          <TopBar />
        </div>

        {/* HEADER */}

       

        {/* TEST ALEATORIU */}

        <section className="teste-contabilitate__random">

          <div className="teste-contabilitate__random-title">

            <FontAwesomeIcon icon={faShuffle} />

            <h2>Test aleatoriu</h2>

          </div>

          <p>
            Primesti un set nou de intrebari selectate
            aleatoriu din banca de exercitii.
          </p>

          <button
            type="button"
            className="teste-contabilitate__random-button"
            onClick={handleRandomTest}
            disabled={loadingTest}
          >

            {loadingVariant === 'random' ? (
              <>
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                />
                {' '}Se genereaza testul...
              </>
            ) : (
              'Genereaza un test'
            )}

          </button>

        </section>

        {/* CELE 50 DE VARIANTE */}

        <section className="teste-contabilitate__variants">

          <div className="teste-contabilitate__section-title">
            <h2>Cele 50 de variante</h2>
          </div>

          <div className="teste-contabilitate__grid">

            {variante.map((numar) => (

              <button
                key={numar}
                type="button"
                className="teste-contabilitate__card"
                onClick={() => handleStartTest(numar)}
                aria-label={`Incepe varianta ${numar}`}
                disabled={loadingTest}
              >

                {loadingVariant === numar ? (

                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                  />

                ) : (

                  numar

                )}

              </button>

            ))}

          </div>

        </section>

        {/* INCARCARE */}

        {loadingTest && (
          <div
            className="teste-contabilitate__loading"
            role="status"
          >

            <FontAwesomeIcon
              icon={faSpinner}
              spin
            />

            <span>
              Se incarca intrebarile...
            </span>

          </div>
        )}

        {/* EROARE */}

        {testError && (
          <div
            className="teste-contabilitate__error"
            role="alert"
          >

            <FontAwesomeIcon
              icon={faCircleExclamation}
            />

            <span>{testError}</span>

          </div>
        )}

      </div>

    </div>
  );
};

export default TesteContabilitate;
